// extracted by mini-css-extract-plugin
module.exports = {"componentWrapper":"create-layer-form_componentWrapper__1MZMF","warning":"create-layer-form_warning__1IMO1"};